import React from "react";
import { View, Text, Image, TouchableOpacity, StyleSheet } from "react-native";
import { AppColors } from "../../../../utility/AppColors";
import ImageComponent from "../../../../Components/ImageComponent";
import { AppImages } from "../../../../utility/AppImages";
import { AppFontStyle } from "../../../../styles/AppFontStyle";

const SaveChangesTooltip = ({ visible }) => {
  if (!visible) return null;

  return (
    <View style={{ flexDirection: "row", gap: 20 }}>
      <View style={{ gap: 10 }}>
        <ImageComponent
          url={AppImages.icDemoImage}
          style={{
            height: 130,
            width: 130,
            // borderRadius: "50%",
          }}
        />
        <View style={{ width: 130 }}>
          <Text style={[AppFontStyle.REGULAR_ANYBODY_12, { lineHeight: 20 }]}>
            <Text style={{ color: AppColors.green_00FFE8 }}>Pro Tip:</Text>
            Checking in early helps you catch any setup issues and ensures a
            professional streaming experience for your audience.
          </Text>
        </View>
      </View>
      <View style={{ flex: 1, gap: 30 }}>
        <View style={{ gap: 5 }}>
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_12,
              { color: AppColors.green_00FFE8 },
            ]}
          >
            Set-Up Stream Reminder 🎥
          </Text>
          <Text style={[AppFontStyle.REGULAR_ANYBODY_12, { lineHeight: 20 }]}>
            Before your event goes live, please check in 60 minutes before the
            scheduled start time. During this check-in period, you’ll be able to
            connect to your streaming software (e.g., OBS or similar) to ensure
            everything is ready for a seamless broadcast.
          </Text>

          <View style={{ gap: 5, marginLeft: 10 }}>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_12, { lineHeight: 20 }]}>
              <Text style={{ color: AppColors.green_00FFE8 }}>
                1. Check-In:
              </Text>{" "}
              Click “Check In” to begin your setup.
            </Text>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_12, { lineHeight: 20 }]}>
              <Text style={{ color: AppColors.green_00FFE8 }}>
                2. Connect to Streaming Software:
              </Text>{" "}
              Open your streaming software (e.g., OBS) and configure it to
              connect with your chosen platform. Make sure your stream settings
              (audio, video quality) are optimised.
            </Text>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_12, { lineHeight: 20 }]}>
              <Text style={{ color: AppColors.green_00FFE8 }}>
                3. Run a Test Stream:
              </Text>{" "}
              Use a quick test to confirm that your stream is broadcasting
              smoothly and that all connections are stable.
            </Text>
          </View>
        </View>
      </View>{" "}
    </View>
  );
};

export default SaveChangesTooltip;
